<template>
    <div class="container">
        <UserNavigation/>
        <div class="text-wrapper">
            <h3>Dostava i plaćanje</h3>
            <p>Plaćanje je moguće pouzećem ili pre slanja uplatom na račun.</p>
            <p>
                Podaci za uplatu na račun su 325-9500600007460-77
                <br>
                Udruženje gradjana "OLIVIA" Nikite Tolstoja 36, 26300 Vršac
                <br>
                Matični: 28122578
                <br>
                Pib: 108214883
            </p>
            <p>Za uplatu na račun najbolje je kontaktirati preko društvenih mreža ili mejla da bi se spojila porudžbina sa dokazom o uplati.</p>
            <p>Isporuke na teritoriji Srbije se vrše u saradnji sa Poštom Srbije. Cena isporuke se naknadno naplaćuje prilikom preuzimanja pošiljke.</p>
            <p>Rok isporuke je 2 do 5 radnih dana.</p>
        </div>
    </div>
</template>

<script>
import UserNavigation from '../UserNavigation'

export default {
    name: 'PaymentAndDelivery',
    components: {
        UserNavigation
    }
}
</script>

<style scoped>
* {
    background: #F0EAD6;
}

.text-wrapper {
    margin-top: 20px;
}

h2 {
    font-weight: bold;
}

p {
    font-size: 1.2rem;
}

ol {
    font-size: 1.2rem;
    margin-left: 5%;
}

ul {
    font-size: 1.2rem;
    margin-left: 8%;
}

</style>